import CounsellorImg from '@/assets/icons/categoryPage/Counsellor.svg';
import { Button, Typography } from '@pwskills/rachnaui';
import Image from 'next/image';
import { useState } from 'react';
import LeadCapture from '../../LeadCapture';
import { LeadCaptureType } from '../../../../interfaces/leadCapture.enum';

interface Props {
  enableOnMobile?: boolean; // used to check if we need hide strip in mobile and tab
  showModal?: boolean; // used to check if we need to show modal or move to hero section
  phoneNumber: string;
  buttonText?: string;
  img?: string;
  msgLineOne?: string;
  msgLineTwo?: string;
  type?: string;
  enquiryType?: string;
  enquiryTypeNPF?: string;
  modalType?: string;
  pageName?: string;
}

const CounsellorConnectStrip = ({
  enableOnMobile = true,
  showModal = false,
  phoneNumber,
  buttonText,
  img,
  msgLineOne,
  msgLineTwo,
  type,
  enquiryType,
  enquiryTypeNPF,
  modalType,
  pageName,
}: Props) => {
  const [openModal, setOpenModal] = useState(false);

  const handleScrollToHeroSection = (href: string) => {
    const section = document.getElementById(href);
    const sectionTop = Number(section?.offsetTop) - 60;

    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <div
        className={`fixed justify-center items-center bottom-0 w-full bg-[#F7E0B4] py-[6px] z-[10000] h-11 ${
          enableOnMobile ? '!flex' : 'hidden large:!flex'
        }`}
      >
        <div className="flex justify-center items-center gap-3 medium:gap-4">
          <div className="flex gap-2 items-center">
            <Image
              src={CounsellorImg}
              alt="confused Icon"
              className="w-[22px] h-[22px] hidden medium:!flex"
            />
            <Typography
              variant="semi-bold"
              component="body-small"
              className="text-[10px] medium:!text-[14px]"
            >
              Talk To Our Counsellor Call{' '}
              <a href={`tel:${phoneNumber}`}>
                <span className="underline cursor-pointer font-bold">{`${phoneNumber}`}</span> OR
              </a>
            </Typography>
          </div>
          <Button
            size="small"
            className=" !text-[10px] !leading:[16px] medium:!text-[14px] medium:!leading-[22px] !px-2 medium:!px-4 !py-1 text-gray-850 !font-bold"
            style={{ backgroundColor: '#FFFFFF' }}
            onClick={() => {
              if (showModal) {
                setOpenModal(true);
              } else {
                handleScrollToHeroSection('category-hero-section');
              }
            }}
          >
            Register Here
          </Button>
        </div>
      </div>
      {openModal && (
        <LeadCapture
          leadCaptureType={LeadCaptureType.MODAL}
          modelOpen={openModal}
          setModelOpen={setOpenModal}
          buttonText={buttonText as string}
          img={img as string}
          msgLineOne={msgLineOne as string}
          msgLineTwo={msgLineTwo as string}
          type={type as string}
          enquiryType={enquiryType as string}
          enquiryTypeNPF={enquiryTypeNPF as string}
          modalType={modalType as string}
          pageName={pageName as string}
          sourceName="footer_counsellor_connect_strip"
        />
      )}
    </>
  );
};

export default CounsellorConnectStrip;
